import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { PermissionService } from '../../../resources/auth/permission.service';
import { Permission } from '../../../resources/models/permission.enum';

@Injectable()
export class AccessDashboardGuard implements CanActivate {
  constructor(
    private permissionService: PermissionService,
  ) {}

  canActivate(): Observable<boolean> {
    return this.permissionService.hasPermission(Permission.ACCESS_DASHBOARD);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/routing/permission-guards/access-dashboard.guard.ts